const SEO = [
	{
		page: "home",
		description:
			"As a Senior Recruitment Consultant, I bring a wealth of experience in travel (W2), perm placements, and locum tenens recruitment, with a strong focus on lead generation, candidate screening, client relationship management, negotiation, and documentation. I am highly skilled in sourcing candidates across a range of platforms, including Vivian Job Diva, Indeed, Facebook, Health Job Nation, Broadbean, Monster, and LinkedIn, enabling me to connect top-tier talent with the right opportunities.",
		keywords: ["Dive", "Dive", "Dive Devadas"],
	},

	{
		page: "about",
		description:
			"As a Senior Recruitment Consultant, I bring a wealth of experience in travel (W2), perm placements, and locum tenens recruitment, with a strong focus on lead generation, candidate screening, client relationship management, negotiation, and documentation. I am highly skilled in sourcing candidates across a range of platforms, including Vivian Job Diva, Indeed, Facebook, Health Job Nation, Broadbean, Monster, and LinkedIn, enabling me to connect top-tier talent with the right opportunities.",
		keywords: ["Dive", "Dive", "Dive Devadas"],
	},

	{
		page: "articles",
		description:
			"Chronological collection of my long-form thoughts on programming, leadership, product design, and more.",
		keywords: ["Dive", "Dive", "Dive Devadas"],
	},

	{
		page: "projects",
		description:
			"I've worked on a variety of projects over the years and I'm proud of the progress I've made. Many of these projects are open-source and available for others to explore and contribute to.",
		keywords: ["Dive", "Dive", "Dive Devadas"],
	},

	{
		page: "contact",
		description:
			"If you're interested in collaborating on a project, feel free to reach out to me. I'm always open to new ideas and opportunities.",
		keywords: ["Dive", "Dive", "Dive Devadas"],
	},
];

export default SEO;
